import React from 'react';
import { Container} from 'reactstrap';
import WhyMonthly from './why-monthly';
import getConfig from 'next/config';
const config = getConfig().publicRuntimeConfig;

const whyMonthly =  [
    {
        title:"It's sustained support",
        message:'It allows for a nonprofit to invest deeply in solving problems and leads to better outcomes for the community they are helping.',
        imgUrl:`${config.cdnUrl}/static/images/home/du19/support@4x.png`,
    },
    {
        title:"It's life-changing",
        message:'You get regular reports and updates about the people you are supporting and the change you are bringing in their lives.',
        imgUrl:`${config.cdnUrl}/static/images/home/du19/life changing@4x.png`,
    },
    {
        title:"It's Practical",
        message:'By giving monthly, you can give what makes sense to you and create an incredible impact over time.',
        imgUrl:`${config.cdnUrl}/static/images/home/du19/practical@4x.png`,
    },

    {
        title:"It's an incredible community",
        message:'You become a part of community of the givers who want to solve the biggest issues India is facing.',
        imgUrl:`${config.cdnUrl}/static/images/home/du19/community@4x.png`,
    }
]


const WhyMonthlyParent = ()=>{
    return(
        <main>
                {/* Why Monthly Panel  */}
                <Container style={{padding:'4rem',borderBottom:'1px solid #3c3c3c'}}>
                    <div style={{textAlign:"center"}}>
                        <p style={{fontSize:'36px',fontWeight:'900'}}>Why Give Monthly</p>
                    </div>

                    <div className="why-monthly-wrapper-component">
                        {
                            whyMonthly.map(item=>{
                                return(
                                    <WhyMonthly item={item}/>
                                )
                            })
                        }

                    <style jsx>
                    {
                        `
                            .why-monthly-wrapper-component{
                                display:flex;
                                flex-wrap:wrap;
                            }

                            @media (max-width:767px){
                                .why-monthly-wrapper-component{
                                    flex-direction:column;
                                }
                            }
                        `
                    }

                    </style>
                    </div>

                </Container>
        </main>


    )
}

export default WhyMonthlyParent;
